export function HelpersLinkFixer (pEditor, pHelpers)
{
  const currentLocation = window.location.toString().replace(/#.*$/mg, "").match(/^.*?\/\/.*?(?=\/)/)[0],
        currentLocalLocation = pHelpers.winLocationHref.replace(new RegExp('^(?:' + currentLocation + ')(.*)', 'i'), '$1').replace(/([.+*?\\\[\]^&$])/g, '\\' + '$1');

  const replaceLinkUrls =
        [
          {
            pattern: new RegExp('^' + currentLocation + '([^A-Za-z0-9-.].*|$)', 'i'),
            replace: function (str, group1)
            {
              return (group1 == null || group1 === '' ? '/' : group1);
            }
          },
          {
            pattern: new RegExp('^(?:' + currentLocalLocation + '|/)#(.*)$', 'i'),
            replace: '#$1'
          },
          {
            pattern: new RegExp('^(?:/?Content/Editor/(?:EditorContentBlank\\.aspx(?:\\?Theme[0-9.]*)?)?)(.*)', 'i'),
            replace: '$1'
          },
          {
            pattern: new RegExp('^(?:/?Sys/Editor/(?:EditorContentBlank(?:\\?Theme[0-9.]*)?)?)(.*)', 'i'),
            replace: '$1'
          },
          {
            pattern: new RegExp('^(?:(?:/?Admin)?/?(?:Events|Members)/Email/(?:ComposeEmail\\.aspx)*)(.*)', 'i'),
            replace: '$1'
          },
          {
            pattern: new RegExp('^(/?)(?:Admin/)+(.+)', 'gi'),
            replace: '$1$2'
          },
          {
            pattern: new RegExp('^/?(?:Admin/)*Admin/?$', 'gi'),
            replace: '/'
          },
          {
            pattern: new RegExp('^Default\\.aspx(.+)', 'ig'),
            replace: '/Default.aspx$1'
          },
          {
            pattern: new RegExp('^/?Default\\.aspx$', 'ig'),
            replace: '/'
          },
          {
            pattern: new RegExp('^(?:\\.\\.\/\\.\\.\/)(.*)', 'gi'),
            replace: '/$1'
          },
          {
            pattern: new RegExp('^(?:\\/Content\\/\\/Content)(.*)', 'gi'),
            replace: '$1'
          },
          {
            pattern: new RegExp('^(?:\\.\\.\/)(.*)', 'gi'),
            replace: '/Content/$1'
          },
          {
            pattern: new RegExp('(.*?)(?:\{|%7B)(.*?)(?:\}|%7D).*', 'ig'),
            replace: function (str, group1, group2)
            {
              function isMacro(str, group1, group2, documentLocation, windowLocation)
              {
                if (!group1 || group1.length === 0)
                {
                  return true;
                }

                const currentUrlParts = documentLocation.replace(/^\//, '').split('/'),
                      windowUrlParts = windowLocation.replace(/^\//, '').split('/'),
                      urlPartsBeforeBrackets = group1.replace(/^\//, '').split('/');

                return (!urlPartsBeforeBrackets || urlPartsBeforeBrackets.length === 0) || // nothing is before the brackets - it is a macro
                       (urlPartsBeforeBrackets.length === 1 && urlPartsBeforeBrackets[0] === '') || // added '/' by IE for sure
                       (currentUrlParts.length > 0 && urlPartsBeforeBrackets.length >= 2 && checkPathContains(currentUrlParts, urlPartsBeforeBrackets)) || // directory is the same for both current url and macro url
                       (windowUrlParts.length > 0 && urlPartsBeforeBrackets.length >= 2 && checkPathContains(windowUrlParts, urlPartsBeforeBrackets)); // directory is the same for both current url and macro url
              }

              function checkPathContains(urlParts, urlPartsBeforeBrackets)
              {
                let i, j;

                for (i = urlPartsBeforeBrackets.length - 2, j = urlParts.length - 2; i >= 0; i--, j--)
                {
                  if (urlPartsBeforeBrackets[i] !== urlParts[j])
                  {
                    return false;
                  }
                }

                return true;
              }

              const winContent = (BEditor.environment.topWindow.contentarea) ? BEditor.environment.topWindow.contentarea : window,
                    isMacroValue = isMacro(str, group1, group2, pEditor.iFrame.location.href, winContent.location.href);

              if (isMacroValue)
              {
                return '{' + group2 + '}'
              }
              else
              {
                return str;
              }
            }
          },
          {
            pattern: new RegExp('^.*?EditorContentBlank/(?:\{|%7B)(.+?)(?:\}|%7D).*$', 'ig'),
            replace: '{$1}'
          }
        ];


  this.fixRelativeUrls = (htmlString) =>
  {
    let result = htmlString;

    result = result.replace(/(<a[\s\r\n][^>]*href\s*=\s*['"])(?!data:)(.*?)(['"][^>]*>)/gi, function(bigStr, beginStr, hrefStr, endStr)
    {
      let i,
          len = replaceLinkUrls.length;

      if (!bigStr.match(/\swa_absurl[\s=>]/))
      {
        hrefStr = hrefStr.replace(replaceLinkUrls[0].pattern, replaceLinkUrls[0].replace);
        hrefStr = hrefStr.replace(replaceLinkUrls[1].pattern, replaceLinkUrls[1].replace);
      }

      for (i = 2; i < len; i++)
      {
        hrefStr = hrefStr.replace(replaceLinkUrls[i].pattern, replaceLinkUrls[i].replace);
      }

      return beginStr + hrefStr + endStr;
    });

    result = result.replace(/(<img[\s\r\n][^>]*src\s*=\s*['"])(?!data:)(.*?)(['"][^>]*>)/gi, function(bigStr, beginStr, srcStr, endStr)
    {
      let i,
          len = replaceLinkUrls.length;

      if (!bigStr.match(/\swa_absurl[\s=>]/))
      {
        srcStr = srcStr.replace(replaceLinkUrls[0].pattern, replaceLinkUrls[0].replace);
        srcStr = srcStr.replace(replaceLinkUrls[1].pattern, replaceLinkUrls[1].replace);
      }

      for (i = 2; i < len; i++)
      {
        srcStr = srcStr.replace(replaceLinkUrls[i].pattern, replaceLinkUrls[i].replace);
      }

      return beginStr + srcStr + endStr;
    });

    return result;
  };
}